import { di } from 'react-magnetic-di';

import { useChatStore } from '../../../controllers/chat-store/main';
import { conversationIsEnded } from '../conversation-status';

/**
 * Derives a boolean indicating whether there are unread messages.
 *
 * - When `conversationId` is omitted: returns `true` if *any* Twilio
 *   conversation in the store has unread messages.
 * - When `conversationId` is provided: returns `true` only if that specific
 *   conversation is non-ended, has a Twilio conversation, and its
 *   `unreadMessagesCount` is greater than 0.
 */
export const useHasUnreadMessages = (conversationId?: string): boolean => {
	di(useChatStore);
	const [{ twilioConversationsWithMetadata, conversations }] = useChatStore();

	if (conversationId) {
		const conversation = conversations[conversationId];
		const twilioMetadata = twilioConversationsWithMetadata[conversationId];
		return (
			!!conversation &&
			!conversationIsEnded(conversation) &&
			!!twilioMetadata?.conversation &&
			(twilioMetadata.unreadMessagesCount ?? 0) > 0
		);
	}

	return Object.values(twilioConversationsWithMetadata ?? {}).some(
		(metadata) => (metadata?.unreadMessagesCount ?? 0) > 0,
	);
};
